import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { TransporterConfigurationEnum } from '../../../../models/enums/configuration.enum';
import { TransporterConfigurationService } from '../../../../services/transporter-configuration.service';
import { OfferEstimation } from '../../../../models/offer-estimation.model';
import { OfferType } from '../../../../models/enums/offer-type.enum';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BaryButtonComponent, BaryCardComponent } from '../../../shared/components';
import { TranslateDirective } from '../../../../directives/translate.directive';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import { BaryIconComponent } from '../../../shared/components/bary-icon/bary-icon.component';

@Component({
  selector: 'jhi-bary-pricing-pack',
  templateUrl: './bary-pricing-pack.component.html',
  styleUrls: ['./bary-pricing-pack.component.scss'],
  standalone: true,
  imports: [MDBBootstrapModulesPro, CommonModule, TranslateModule, BaryButtonComponent, TranslateDirective, BaryIconComponent, BaryCardComponent],
})
export class BaryPricingPackComponent implements OnInit {
  readonly #transporterConfigurationService = inject(TransporterConfigurationService);

  @Input() offerEstimation!: OfferEstimation;
  @Input() isSelectedOffer = false;

  @Output() estimateEvent = new EventEmitter<any>();

  public hasFlexibleConfig: boolean = false;

  protected readonly FaDirectiveEnum = FaDirectiveEnum;

  public ngOnInit() {
    this.#transporterConfigurationService
      .getBooleanConfiguration(TransporterConfigurationEnum.ACTIVATION_FLEXIBILITY_DEADLINE)
      .subscribe(val => (this.hasFlexibleConfig = val as boolean));
  }

  public handleEstimate(): void {
    this.estimateEvent.emit(this.offerEstimation);
  }

  public selectButtonLabel(): string {
    return this.offerEstimation.type === OfferType.QUOTATION ? 'BTN.QUOTATION_REQUEST' : 'BARY_LIGHT_ESTIMATE.BTN.SELECTED_OFFER';
  }
}
